import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "position-absolute top-0 start-0 mx-5 mt-5 d-lg-block w-200px w-md-200px w-xl-220px mb-sm-5 mb-lg-0",
  src: "media/logos/MIGU.Gob.jpg",
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "text-center mb-10" }
const _hoisted_4 = { class: "text-dark mb-3" }
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = { class: "d-flex flex-stack mb-2" }
const _hoisted_9 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "d-flex flex-stack mb-2" }
const _hoisted_13 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_18 = { class: "indicator-label" }
const _hoisted_19 = { class: "indicator-progress" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.passwordConfirm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("authConfirmationPasswordTitulo")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.messageError), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("authSigninPasswordLabel")), 1)
          ]),
          _createVNode(_component_Field, {
            name: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
          }, {
            default: _withCtx(({ field }) => [
              _withDirectives(_createElementVNode("input", _mergeProps({
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                ref: "passwordInput"
              }, field), null, 16), [
                [_vModelText, _ctx.password]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("authConfirmationPasswordPassword2Label")), 1)
          ]),
          _createVNode(_component_Field, {
            name: "password2",
            modelValue: _ctx.password2,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password2) = $event))
          }, {
            default: _withCtx(({ field }) => [
              _withDirectives(_createElementVNode("input", _mergeProps({
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password2) = $event)),
                ref: "password2Input"
              }, field), null, 16), [
                [_vModelText, _ctx.password2]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_ErrorMessage, { name: "password2" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("authSigninSigninBtn")), 1),
            _createElementVNode("span", _hoisted_19, [
              _createTextVNode(_toDisplayString(_ctx.$t("indicatorProgress")) + " ", 1),
              _hoisted_20
            ])
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}